import { createSlice, PayloadAction } from '@reduxjs/toolkit';


// 获取原始数据
const getOriRecommendPlaceMapInfo = (): any => ({
  searchParams: null, // 筛选条件
  filterCity: null, // 筛选条件-城市
  /* 地图搜索数据（关键词搜索出来的地图数据）
  [{
    "key": "Hair 1",
    "source": "amap",
    "name": "Hair 1",
    "address": "圣十字径41号",
    "lng": 114.226954,
    "lat": 22.278586
  }] */
  mapData: [],
  /* 当前选择的场地信息
  {
    "source": "place",
    "name": "杭州西溪八方城",
    "key": 2078,
    "city": "杭州市",
    "address": "杭州市余杭区",
    "lng": "120.046083",
    "lat": "30.289958"
  }
 */
  selectedPlaceData: null,
  amapLocationInfo: null, // 高德地图搜索出的选中的地点信息
});


interface InitStata {
  number: number;
  recommendType:boolean,
  editNeedValidate:boolean;
  recommendPlaceMapInfo:any
}

const initialState: InitStata = {
  number: 0,
  recommendType: false,
  editNeedValidate: false, // 从列表页，详情页跳转到编辑页需要校验表单
  recommendPlaceMapInfo: getOriRecommendPlaceMapInfo(),
};

const customerSlice = createSlice({
  name: 'demand',
  initialState,
  reducers: {
    changeCount: (state = initialState, action: PayloadAction<number>) => {
      state.number = action.payload;
    },
    changeRecommendType: (state = initialState, action: PayloadAction<boolean>) => {
      state.recommendType = action.payload;
    },
    changeEditNeedValidate: (state = initialState, action: PayloadAction<boolean>) => {
      state.editNeedValidate = action.payload;
    },
    /* 场地推荐-地图模式 start */
    // 重置 recommendPlaceMapInfo
    resetRecommendPlaceMapInfo(state = initialState) {
      state.recommendPlaceMapInfo = getOriRecommendPlaceMapInfo();
    },
    // 更新筛选条件
    updateSearchParams: (state = initialState, action: PayloadAction<any>) => {
      // console.log('action.payload', action.payload);
      state.recommendPlaceMapInfo.searchParams = action.payload;
    },
    // 筛选条件-城市
    updateFilterCity: (state = initialState, action: PayloadAction<any>) => {
      state.recommendPlaceMapInfo.filterCity = action.payload;
    },
    // 更新通过关键词搜索出来的地图数据
    updateMapData: (state = initialState, action: PayloadAction<any[]>) => {
      state.recommendPlaceMapInfo.mapData = action.payload;
    },
    // 更新选择的场地信息
    updateSelectedPlaceData: (state = initialState, action: PayloadAction<any>) => {
      state.recommendPlaceMapInfo.selectedPlaceData = action.payload;
    },
    // 更新高德地图地点信息
    updateAmapLocationInfo: (state = initialState, action: PayloadAction<any>) => {
      state.recommendPlaceMapInfo.amapLocationInfo = action.payload;
    },
    /* 场地清单-地图模式 end */
  },
});

// 导出action
export const { changeCount, changeRecommendType, changeEditNeedValidate,
  resetRecommendPlaceMapInfo, updateSearchParams, updateFilterCity, updateMapData, updateSelectedPlaceData, updateAmapLocationInfo
} = customerSlice.actions;

export default customerSlice.reducer;
